import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';

// Ambient "living-system" depth: a faint masked dot grid that slowly drifts, plus an
// optional static glow. Sits behind a section's content. Tasteful, not particles.
const GRID_STYLE = {
  backgroundImage:
    'radial-gradient(circle, rgba(0,0,0,0.06) 1px, transparent 1.4px)',
  backgroundSize: '30px 30px',
  maskImage:
    'radial-gradient(ellipse 85% 75% at 50% 35%, #000 38%, transparent 88%)',
  WebkitMaskImage:
    'radial-gradient(ellipse 85% 75% at 50% 35%, #000 38%, transparent 88%)',
};

export const IntelligentBackdrop = ({ glow = false, className = '' }) => {
  const reduce = useReducedMotion();
  return (
    <div className={`absolute inset-0 overflow-hidden pointer-events-none ${className}`} aria-hidden="true">
      {/* faint dot grid — slowly drifts ~1 cell so it reads as a living system.
          Oversized (inset -40px) so the drift never reveals an edge. */}
      <motion.div
        className="absolute"
        style={{ top: -40, left: -40, right: -40, bottom: -40, ...GRID_STYLE }}
        animate={reduce ? undefined : { x: [0, 30, 0], y: [0, 18, 0] }}
        transition={reduce ? undefined : { duration: 18, repeat: Infinity, ease: 'easeInOut' }}
      />
      {/* optional static glow (off by default to avoid stacking with existing glows) */}
      {glow && (
        <div className="absolute left-1/2 -top-1/4 -translate-x-1/2 w-[55%] h-[55%] rounded-full bg-[#FF6A00]/[0.06] blur-[130px]" />
      )}
    </div>
  );
};

export default IntelligentBackdrop;
